'use es6';

import I18n from 'I18n';

var isExpired = function isExpired(removedAt) {
  var now = I18n.moment().valueOf();
  return removedAt && removedAt < now;
};

export var buildTrialState = function buildTrialState(createdAt, endsAt, removedAt, id) {
  return {
    inTrial: !isExpired(removedAt) ? {
      createdTs: createdAt,
      expiresTs: endsAt
    } : null,
    hasTrialed: isExpired(removedAt) ? {
      lastTrialStarted: createdAt,
      lastTrialExpired: removedAt
    } : null,
    id: id
  };
};